<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-8">
                <div class="row">
                    <div class="col-12 pt-4 px-4">
                        <h5>
                            <img src="../assets/images/person.svg" alt="">
                            Hello {{ $store.getters["auth/firstName"]}}, your estimated savings to date are <span
                                class="text-success">£{{savings}}</span></h5>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <striketrough><span class="font-weight-bold heading">My properties</span></striketrough>
                        <p class="text-muted text-center" v-if="!properties.length">You haven't added any properties at the moment</p>
    
                        <div class="card shadow-sm" v-else>
                            <div class="card-body">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" v-for="(prop, key) in properties" :key="key">
                                        {{ prop.currentPropertyAddress }}
                                        <button class="btn btn-link float-right" @click="$router.push({name: 'ProfileSettings', query: {property: prop.id}})"><i class="fa fa-pencil"></i></button>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-footer bg-white border-top-0 pt-0">
                                <a href="#" @click.prevent="$refs.modal.show()" class="float-right"><i class="fa fa-plus"></i> Add another
                                    property</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <striketrough><span class="font-weight-bold heading">Updates</span></striketrough>
                        <p class="text-muted text-center" v-if="!notifications.length">No updates for you right now.</p>
                        
                        <notification v-else v-for="(notif) in notifications" :key="notif.id" :notification="notif" />
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <button class="btn btn-lg btn-block btn-info btn-info-gradient mooving-home" @click="$refs.moveModal.show()">
                    <img src="../assets/images/home_icon.png" alt="">
                    MOVING HOME?
                </button>
                <div class="invite">
                    <p class="h3">Invite Your Friends</p>
                    <p class="h4">and</p>
                    <p class="display-4 font-weight-bolder">Get &pound;{{globalRewardAmount}}</p>
                    <p class="h3">for every friends
                        that switches</p>
                    <button class="btn btn-lg btn-block btn-success btn-success-gradient " @click="$router.push({name: 'ProfileRewards'})">INVITE</button>
                </div>
            </div>
        </div>
        <address-modal ref="modal" @selected="onAddressSelected"/>
        <move-modal ref="moveModal" />
    </div>
</template>

<script>
import Striketrough from "@/components/support/Striketrough";
import AddressModal from "@/components/setup/AddressModal";
import MoveModal from "@/components/profile/MoveModal";
import api from "@/utils/api"
import Notification from "@/components/profile/Notification";
import types from "@/components/profile/Notification";
import ClearStoreMixin from "@/mixins/ClearStoreMixin";
import RewardHelper from "@/mixins/RewardHelper";
import store from "@/store";

export default {
        name: "Dashboard",
        components: {Notification, MoveModal, AddressModal, Striketrough},
        mixins: [ClearStoreMixin,RewardHelper],
        data: function () {
            return {
                properties: [],
                notifications: [],
                types: types,
                savings: 0
                
            }
        },
        mounted() {
            let that = this;
            api.properties().then(response => {
                that.properties = response.data.data;
            })
            api.notifications().then(response => {
                that.notifications = response.data.data;
            })
            api.savings().then(response => {
                that.savings = response.data.data.savings
            })
        },
        methods: {
            onAddressSelected: function (address) {
                this.clearStore()
                this.$store.commit('setup/setAddress', address);
                this.$router.push({name: 'SetupHome'})
            }
        },
        beforeRouteEnter: (to, from, next) => {
            api.balance().then(response => {
                store.commit('auth/balance', response.data.data.balance);
            })
            next();
        }
    }
</script>

<style scoped lang="scss">
    @import "../sass/base";

    @include media-breakpoint-down(lg) {
        .border-right {
            border-right: none !important;
        }
    }

    @include media-breakpoint-up(lg) {
        .border-bottom {
            border-bottom: none !important;
        }
    }

    .avatar {
        width: 40px;
        height: 40px;
    }

    .heading {
        font-size: 1rem;
    }

    .mooving-home {
        height: 4rem;
        
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            margin-right: 0.5rem;
        }
        @include media-breakpoint-up(lg) {
            margin-top: 5.3rem;
        }
    }
    .invite {
        background-image: url("../assets/images/invite_bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        color: $white;
        text-align: center;
        padding: 2rem;
        margin-top: 1rem;
        border-radius: $border-radius;
        > p {
            margin-bottom: 1rem;
        }

        > button {
            height: 3.2rem;
            margin-top: 3rem;
        }
    }
</style>
